export const styles = {
  navbar:
    "w-full h-20 shadow-card z-50 relative flex overflow-hidden items-center",
};
